import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { server } from "../server";
import { getUserIdFromToken } from "../utils/auth";

const API_URL = `${server}/ChatList/GetChatListByUserId`;

export const fetchChatList = createAsyncThunk(
  "chatList/fetchChatList",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const userId = await getUserIdFromToken();

      const response = await fetch(`${API_URL}?userId=${userId}`, {
        headers: {
          Authorization: token,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        return rejectWithValue(errorData);
      }

      const data = await response.json();
      return data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const chatListSlice = createSlice({
  name: "chatList",
  initialState: {
    chats: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchChatList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChatList.fulfilled, (state, action) => {
        state.loading = false;
        state.chats = action.payload;
      })
      .addCase(fetchChatList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default chatListSlice.reducer;
